import { apiCall } from "./auth";
import { API_URL } from "./config";


//buildsheet
export const addbuildsheet = (data) => apiCall(`${API_URL}buildsheet/addbuildsheet`, "POST",data);
export const getbuildsheet = (data) => apiCall(`${API_URL}buildsheet/getbuildsheet`, "POST",data);
export const getallbuildsheet = (data) => apiCall(`${API_URL}buildsheet/getallbuildsheet`, "POST",data);
export const getbuildsheetdata = (data) => apiCall(`${API_URL}buildsheet/getbuildsheetdata`, "POST",data);
export const getinsights = (data) => apiCall(`${API_URL}buildsheet/insightdata`, "POST",data);

export const deletebuildsheetdata = (data) => apiCall(`${API_URL}buildsheet/deletebuildsheetdata`, "POST",data);
export const getsinglebuilsheet = (data) => apiCall(`${API_URL}buildsheet/getsinglebuilsheet`, "POST",data);
export const updatebuildsheetdata = (data) => apiCall(`${API_URL}buildsheet/updatebuildsheetdata`, "POST",data);
export const upateBuildSheetStatus = (data) => apiCall(`${API_URL}buildsheet/upateBuildSheetStatus`, "POST",data);
export const getallbuildsheetfilter = (data) => apiCall(`${API_URL}buildsheet/getallbuildsheetfilter`, "POST",data);
export const addbuildsheetapi = (data) => apiCall(`${API_URL}buildsheet/addNewbuildsheet`, "POST",data);
